import { useParams } from "@tanstack/react-router";
import PrestationForm from "@features/creation/prestations/components/PrestationForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import api from "@lib/utils/api";
import { Pencil } from "lucide-react";

export const Route = createFileRoute("/_app/creation/prestations/$id/edit")({
  loader: requirePermission(PERMISSIONS.CREATION.PRESTATIONS.EDIT),
  staticData: {
    title: "Modifier prestation",
    icon: Pencil,
    permission: PERMISSIONS.CREATION.PRESTATIONS.EDIT,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: EditPrestationPage,
});

function usePrestationDetail(id) {
  return useQuery({
    queryKey: ["prestations", id],
    queryFn: async () => {
      const response = await api.get(`/prestations/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
}

function EditPrestationPage() {
  const { id } = useParams({ from: "/_app/creation/prestations/$id/edit" });
  const { data: prestation, isLoading } = usePrestationDetail(id);

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Modifier la prestation</h1>
          <p className="text-sm text-base-content/60">
            Modifier les informations de la prestation
          </p>
        </div>
        <div className="space-y-4">
          <div className="skeleton h-12 w-full" />
          <div className="skeleton h-24 w-full" />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Modifier la prestation</h1>
        <p className="text-sm text-base-content/60">
          Modifier les informations de la prestation {prestation?.code}
        </p>
      </div>
      <PrestationForm prestation={prestation} />
    </div>
  );
}
